import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

/**
 * Checks is a url contains any facet info.  If a user has chosen a facet it will
 * be added to the URL like this.
 *
 * https://www.drhorton.com/texas/austin#f:Bathrooms=[3]
 *
 * @param url - The url to add the hash value to.
 * @param paramName - The name of the param to add, if this matches a param that already exists the value will be replaced.
 * @param paramValue - The value of the param to add, if this matches a param that already exists the value will be replaced.
 * @returns A url with the added hash param added.
 */
export const addUrlHashParam = (
	url: URL,
	paramName: string,
	paramValue: string,
): URL => {
	let urlHashParams = new URLSearchParams(url.hash.substring(1));

	urlHashParams.set(paramName, paramValue);

	url.hash = decodeURIComponent(urlHashParams.toString());

	return url;
};
